// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";

import * as uiHelpers from "../StateUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../_metronic/_partials/controls";
import { useStateUIContext } from "../StateUIContext";

export function StateTable({
  isLoading,
  stateList,
  filterValues,
  currentPage,
  stateListTotalCount,
  setCurrentPage,
}) {
  // State UI Context
  const stateUIContext = useStateUIContext();
  const stateUIProps = useMemo(() => {
    return {
      ids: stateUIContext.ids,
      setIds: stateUIContext.setIds,
      queryParams: stateUIContext.queryParams,
      setQueryParams: stateUIContext.setQueryParams,
      openReceiptDialog: stateUIContext.openReceiptDialog,
      openDeleteDialog: stateUIContext.openDeleteDialog,
      openEditDialog: stateUIContext.openEditDialog,
    };
  }, [stateUIContext]);

  // Table columns
  const columns = [
    // {
    //   dataField: "id",
    //   text: "ID",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   style: {
    //     minWidth: "110px",
    //   },
    // },
    {
      dataField: "state_name",
      text: "STATE",
      sort: true,
      formatter: columnFormatters.StateNameTypeFormatter,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "state_code",
      text: "STATE CODE",
      sort: true,
      formatter: columnFormatters.StateCodeTypeFormatter,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "countryId",
      text: "COUNTRY",
      formatter: columnFormatters.CountryTypeFormatter,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "status",
      text: "STATUS",
      formatter: columnFormatters.StatusTypeFormatter,
      style: {
        minWidth: "110px",
      },
    },
    // {
    //   dataField: "deleted_at",
    //   text: "DELETED",
    //   formatter: columnFormatters.DeleteTypeFormatter,
    //   style: {
    //     minWidth: "110px",
    //   },
    // },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openReceiptDialog: stateUIProps.openReceiptDialog,
        openDeleteDialog: stateUIProps.openDeleteDialog,
        openEditDialog: stateUIProps.openEditDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "80px",
      },
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: stateListTotalCount ? stateListTotalCount : 0,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: stateUIProps.queryParams.pageSize,
    page: currentPage,
    onPageChange: (page) => {
      if (page === 0) return;
      setCurrentPage(page);
    },
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination isLoading={isLoading} paginationProps={paginationProps}>
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-head-bg table-borderless table-vertical-center state-table"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={stateList ? stateList : []}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  stateUIProps.setQueryParams
                )}
                {...paginationTableProps}
              ></BootstrapTable>
              <PleaseWaitMessage isLoading={isLoading} />
              <NoRecordsFoundMessage
                entities={stateList}
                errorMessage={"No states found!"}
              />
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
